import { MapRouteInfo } from 'shared/components/TransportAccessibility';
import { EMapService } from 'shared/types/map';

export const getMapRouteInfoComponent = (mapService: EMapService | null) => {
  return mapService === EMapService.TransportAccessibility ? MapRouteInfo : undefined;
};
